import { T, RecordProps, Rectangle2d, ShapeUtil, HTMLContainer } from "tldraw";

import {
  FeedShape,
  TargetPlaceholderShape,
  targetPlaceholderType,
} from "@/components/canvas-editor/shapes/shapes";
import { cn } from "@/lib/utils";

export class TargetPlaceholderShapeUtil extends ShapeUtil<TargetPlaceholderShape> {
  static override type = targetPlaceholderType;

  static override props: RecordProps<TargetPlaceholderShape> = {
    w: T.number,
  };

  override getDefaultProps() {
    return { w: 100 };
  }

  override canResize() {
    return false;
  }

  override component(shape: FeedShape) {
    return (
      <HTMLContainer
        className="bg-slate-12 dark:bg-slatedark-12 border border-slate-12 dark:border-slatedark-12 relative"
        style={{
          height: 4,
          width: shape.props.w,
        }}
      >
        <div
          className={cn(
            "absolute left-1 top-1/2 -translate-x-full -translate-y-1/2",
            "h-3 w-3 rounded-full bg-slate-12 dark:bg-slatedark-12",
          )}
        />
        <div
          className={cn(
            "absolute right-1 top-1/2 translate-x-full -translate-y-1/2",
            "h-3 w-3 rounded-full bg-slate-12 dark:bg-slatedark-12",
          )}
        />
      </HTMLContainer>
    );
  }

  override getGeometry(shape: FeedShape) {
    return new Rectangle2d({
      width: shape.props.w,
      height: 10,
      isFilled: true,
    });
  }

  indicator(shape: FeedShape) {
    return <rect width={shape.props.w} height={10} />;
  }
}
